import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
import { TraceabilitySankey } from '../TraceabilitySankey';
import { mockLegendColors, mockSankeyData } from './MockData';
import { MockGraphCover } from '@app/_components/lf-graph/MockGraphCover';
export const MockSankey: FC<{
  title: string;
}> = t0 => {
  const $ = _c(3);
  const {
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TraceabilitySankey data={mockSankeyData} legendColors={mockLegendColors || {}} mock={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <MockGraphCover coverText={title}>{t1}</MockGraphCover>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};